import { Guid } from "@/Common/Models/Guid";

interface CareComponentConfiguration {
    Name: string;
    CareElements: CareElementConfiguration[];
    IsExpanded?: boolean;
}

interface CareElementConfiguration {
    Name: string;
}

enum CreateFlowsheetTemplateScope {
    Patient = 1,
    Physician = 2,
    Clinic = 3
}

interface CreateFlowsheetTemplateRequest {
    FlowsheetTemplateCreateType: CreateFlowsheetTemplateScope;
    Name: string;
    CareComponentConfigurations: CareComponentConfiguration[];
    FlowsheetId?: Guid;
    PatientId?: Guid;
}

export {
    CreateFlowsheetTemplateRequest,
    CreateFlowsheetTemplateScope
};
